export default API => ({
	// 职业列表新接口
	getMaasVocation(params) {
		return API({
			url: `/task/v1/task/getMaasVocation`,
			method:"get",
			params
		})
	},
	// 获取图片链接
	uploadPicture(data) {
		return API({
			url: `/resource/v1/resource/uploadPicture`,
			method: 'post',
			data,
		})
	},
	// 渠道商入驻申请
	saveHumanSocietyChannelBranchApply(data) {
		return API({
			url: `/usercenter/v1/branchApplyRecord/saveHumanSocietyChannelBranchApply`,
			method: 'post',
			data,
		})
	},
	//获取考试认证信息
	findUserAnnexByParam(params) {
		return API({
			url: `/usercenter/v1/user/findUserAnnexByParam`,
			method: 'get',
			params
		})
	},
	//考试认证信息保存
	saveUserAnnexByParam(data) {
		return API({
			url: `/usercenter/v1/user/saveUserAnnexByParam`,
			method: 'post',
			data
		})
	},

	//获取我的证书
	getMyCertList(params) {
		return API({
			url: `/affairs/v1/cert/getMyCertList`,
			method: 'post',
			params
		})
	},
	// 生成准考证
	createMyCert(data) {
		return API({
			url: `/affairs/v1/cert/createMyCert`,
			method: 'post',
			data
		})
	},
	//查看下载考证
	downLoadMyCert(data) {
		return API({
			url: `/affairs/v1/cert/downLoadMyCert`,
			method: 'post',
			data
		})
	},
	//查看成绩(考试计划查询考试记录)
	findScoreByPlanId(params) {
		return API({
			url: `/affairs/v1/examinationPlanTask/findByPlanId`,
			method: 'get',
			params
		})
	},
    // 查询等级list
    findListBySaasId(id) {
        return API({
          url: `/order/v1/goodsLevel/findListBySaasId` ,
        });
    },
})